import { Tooltip, Button, Modal, Tag, Row, Col } from "antd";
import React, { Component } from "react";
import { Typography } from "antd";

import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import i18next from "i18next";
const { Text } = Typography;
class HintModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleModel: false,
    };
  }

  dummyData = {
    home: [],
    accounts: [
      {
        key: "DESCRIPTION",
        value: "In this page you will be able to view all Accounts",
        type: "text",
        style: {
          color: "red",
        },
      },
      {
        key: "CARD",
        value: "View Account Details by clicking on the card ",
        type: "text",
        style: {
          color: "blue",
        },
      },
    ],
    createAccounts: [
      {
        key: "package Code",
        value: "Silver-Gold-Platinum",
        type: "text",
        style: {
          color: "blue",
        },
      },
      {
        key: "description",
        value: "In this page you will be able to create Account",
        type: "text",
        style: {
          color: "red",
        },
      },
      {
        key: "Admin Checkbox",
        value: "add another Admin to help you ",
        type: "text",
        style: "",
      },
    ],
    editAccounts: [
      {
        key: "description",
        value: "In this page you will be able to edit all Accounts",
        type: "text",
        style: {
          color: "red",
        },
      },
    ],
    viewAccounts: [
      {
        key: "description",
        value: "In this page you will be able to view all Accounts",
        type: "text",
      },
    ],
    addAccountNumbers: [
      {
        key: "description",
        value: "In this page you will be able to add new number to the Account",
        type: "text",
      },
    ],
    manageAccountNumbers: [
      {
        key: "description",
        value: "In this page you will be able to manage Account number",
        type: "text",
      },
    ],
    createAdminAccount: [
      {
        key: "description",
        value: "In this page you will be able to Create new Admin",
        type: "text",
      },
    ],
    dashboard: [],
    adminDashboard: [
      {
        key: "DESCRIPTION",
        value:
          "In this page admin will be able to view dashboard and generate stat",
        type: "text",
        style: {
          color: "red",
        },
      },
    ],
    agentDashboard: [
      {
        key: "description",
        value: "In this page agent will be able to view  dashboard",
        type: "text",
      },
    ],
    accountMSISDNTable: [
      {
        key: "description",
        value: "In this page you will be able to view MSISDN table",
        type: "text",
      },
    ],
    createAccountMSISDN: [
      {
        key: "description",
        value: "Create MSISDN Account",
        type: "text",
      },
    ],
    system: [
      {
        key: "description",
        value: "In this page you will be able to view system Details",
        type: "text",
        style: {
          color: "red",
        },
      },
    ],
    packages: [],
    createPackages: [],
    editPackages: [],
    users: [],
    createUsers: [],
    editUsers: [],
    viewUsers: [
      {
        key: "description",
        value: "In this page you will be able to view User Details",
        type: "text",
        style: {
          color: "red",
        },
      },
    ],
    groups: [],
    createGroups: [],
    editGroups: [],
    viewGroups: [],
    cdrs: [],
    oneStepCallFlowConfig: [],
    callFlowConfig: [],
    promptsConfig: [],
    agentChangeStatusReport: [],
    profile: [],
    changePassword: [],
  };

  createModal(data) {
    let renderArray = [];

    //check if no data
    if (data) {
      //check if there is a list (length > 0 to loop )
      if (data.length > 0) {
        data.forEach((element) => {
          renderArray.push(
            <Col>
              <Text className="small-text"> {element.key}</Text>
              <Tag className="m-2">{element.value}</Tag>
            </Col>
          );
        });
        return renderArray;
      } else {
        //else render the one  that exist
        return (
          <div>
            <p> No Data To Show ... !</p>
          </div>
        );
      }
    }
  }

  showModal = () => {
    this.setState({ visibleModel: true });
  };
  handleOk = () => {
    this.setState({ visibleModel: false });
  };
  handleCancel = () => {
    this.setState({ visibleModel: false });
  };

  render() {
    return (
      <div>
        <Button
          className="helpBtn"
          type="primary"
          shape="circle"
          icon="question"
          onClick={this.showModal}
          style={{ display: "none" }}
        ></Button>
        <Modal
          title="Information Modal"
          visible={this.state.visibleModel}
          onCancel={this.handleCancel}
          footer={[
            <Button
              key="Ok"
              className="ant-btn-primary"
              onClick={this.handleOk}
            >
              Ok
            </Button>,
          ]}
        >
          <Row>
            {this.createModal(
              this.dummyData[this.props.context.currentComponent]
            )}
          </Row>
        </Modal>
      </div>
    );
  }
}

export default withSharedStateConsumer(HintModal);
